import { AxiosResponse } from 'axios';
import { ZodType } from 'zod';
import { ApiErrorData, ApiErrorDataDto } from './api.types';

/**
 * Creates a middleware that parses the data field of an Axios response
 * using the provided zod schema.
 *
 * @param schema - The zod schema to use for parsing the data field.
 * @returns A middleware that takes an Axios response and returns a new
 * Axios response with the parsed data field.
 */
export const responseContract = <Data>(schema: ZodType<Data>) => {
  return (response: AxiosResponse<unknown>): AxiosResponse<Data> => {
    const data = schema.parse(response.data);

    return { ...response, data };
  };
};

// TODO: may not have validation errors, might be overkill, i'll test it later
/**
 * Normalize validation errors from the API into a flat list of strings.
 *
 * Example:
 * {
 *   "username": ["This field is required."],
 *   "password": ["This field may not be blank."]
 * }
 * =>
 * ["username This field is required.", "password This field may not be blank."]
 */
export const normalizeValidationErrors = (
  data: ApiErrorDataDto,
): ApiErrorData => {
  return data.errors.map(({ error, detail }) =>
    detail ? detail : error ?? '',
  );
};
